import { Direction } from './direction.enum';

export class Subdivision implements ISubdivsion {
    code: string;
    directions: Array<Direction> = new Array<Direction>();

    constructor(subdivision: ISubdivsion) {
        if (subdivision !== undefined && subdivision !== null) {
            this.code = subdivision.code;
            this.directions = subdivision.directions;
        }
    }
}

export interface ISubdivsion {
    code: string;
    directions: Array<Direction>;
}